import { action, makeObservable, observable, reaction } from 'mobx';
import { parseNumberByPrecision } from '@pascal/pascal-core';
import { iframeService } from '../services/iframeService';
import { userInfoStore } from './userInfoStore';

export class ApplicationStore {
  accessToken = '';

  isAuthenticated = false;

  isAuthDataReceived = false;

  isCardsGame = false;

  isDemo = false;

  demoBalance = 50000;

  demoSpinId = 0;

  isSocketConnected = false;

  hasRealModeSwitcher = false;

  isKeno8 = false;

  partnerSkin = 0;

  isTurboMode = true;

  constructor() {
    makeObservable(this, {
      isDemo: observable,
      isKeno8: observable,
      demoBalance: observable,
      partnerSkin: observable,
      isCardsGame: observable,
      accessToken: observable,
      isAuthenticated: observable,
      isSocketConnected: observable,
      isAuthDataReceived: observable,
      hasRealModeSwitcher: observable,
      isTurboMode: observable,
      setIsKeno8: action.bound,
      setIsDemo: action.bound,
      setIsTurboMode: action.bound,
      setIsCardsGame: action.bound,
      setAccessToken: action.bound,
      setIsAuthenticated: action.bound,
      decreaseDemoBalance: action.bound,
      increaseDemoBalance: action.bound,
      setIsSocketConnected: action.bound,
      setIsAuthDataReceived: action.bound,
      setHasRealModeSwitcher: action.bound,
      setPartnerSkin: action.bound,
    });
    reaction(
      () => this.demoBalance,
      (value) => {
        if (value < 100) {
          this.demoBalance = 50000;
        }
      }
    );
  }

  setIsTurboMode(bool) {
    this.isTurboMode = bool;
  }

  setIsKeno8(bool) {
    this.isKeno8 = bool;
  }

  setHasRealModeSwitcher(bool) {
    this.hasRealModeSwitcher = bool;
  }

  demoSwitcher(demoSwitcherAdditionalFunction) {
    if (this.isAuthenticated) {
      this.setIsDemo(false);
      if (demoSwitcherAdditionalFunction) {
        demoSwitcherAdditionalFunction();
      }
    } else {
      iframeService.sendPgLogin();
    }
  }

  getDemoSpinId() {
    this.demoSpinId += 1;
    return this.demoSpinId;
  }

  setIsSocketConnected(bool) {
    this.isSocketConnected = bool;
  }

  setIsDemo(value) {
    this.isDemo = value;
  }

  decreaseDemoBalance(amount) {
    this.demoBalance = parseNumberByPrecision(
      this.demoBalance - amount,
      1,
      userInfoStore.precision
    );
  }

  increaseDemoBalance(amount) {
    this.demoBalance = parseNumberByPrecision(
      this.demoBalance + amount,
      1,
      userInfoStore.precision
    );
  }

  setIsCardsGame(bool) {
    this.isCardsGame = bool;
  }

  setAccessToken(accessToken) {
    this.accessToken = accessToken;
  }

  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  }

  setPartnerSkin(skin) {
    this.partnerSkin = skin;
  }

  setIsAuthDataReceived(isAuthDataReceived) {
    this.isAuthDataReceived = isAuthDataReceived;
  }
}

export const applicationStore = new ApplicationStore();
